import { AxiosResponse } from 'axios';
import { TFunction } from 'i18next';

import {getProviderSecurityMapping, getSummaryEnquiry} from './dao/EnquiryDao';
import { displayError } from '../component/Message/Message';

import { EnquirySummary } from '../model/EnquirySummary';
import { ProviderMappingResponse } from '../model/ProviderMappingResponse';

//
// Get an enquiry summary
//
export const enquirySummary = (token: string, enquiryId: string, t: TFunction): Promise<AxiosResponse<EnquirySummary>> =>
  getSummaryEnquiry(token, enquiryId)
    .catch((error: any) => {
      displayError(`${t('summary.service.summary.error')} ${error.message}`);
      return Promise.reject(new Error(error));
    });

//
// Get provider security config
//
export const getProviderMapping = (token: string, t: TFunction): Promise<AxiosResponse<ProviderMappingResponse>> =>
  getProviderSecurityMapping(token)
    .catch((error: any) => {
      displayError(`${t('summary.service.provider.mapping.error')} ${error.message}`);
      return Promise.reject(new Error(error));
    });